import React, {memo} from 'react';
import styled from 'styled-components';
import {TscStyles, TscThemeName, TscThemeNames} from '@techsmith/tsc-cloud-style-guide';
import {useTscTheme} from '../../context/themeProvider';

const HorizontalSeparatorContainer = styled.span<{theme: TscThemeNames}>`
   margin-left: .5rem;
   margin-right: .5rem;
   display: inline-block;
   color: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.ui.dusk.light : TscStyles.color.ui.dusk.dark};
`;

const HorizontalSeparator: React.FC = () => {
   const theme = useTscTheme();

   return (
      <HorizontalSeparatorContainer
         data-test-id="horizontal-separator"
         theme={theme}
      >
         |
      </HorizontalSeparatorContainer>
   );
};

export default memo(HorizontalSeparator);
